import { showTokenTransactionPopup } from '@/core/presenter/controller/PopupController';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  tokenTransaction: ViewModel.IResponseActivity;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TokenTransactionItem = ({ tokenTransaction }: IProps) => {
  const handleClickTokenTransactionItem = useCallback(() => {
    showTokenTransactionPopup(tokenTransaction);
  }, [tokenTransaction]);

  const handleCopyClick = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.stopPropagation();

    const text = tokenTransaction.type === '보내기' ? tokenTransaction.to : tokenTransaction.from;
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <li data-type={tokenTransaction.type} onClick={handleClickTokenTransactionItem}>
        <a href="#">
          <div className="date">{tokenTransaction.date}</div>
          <div className="row">
            <div className="left">
              <div className="icotxt">
                <div className="icon-area">
                  <img
                    src={`img/con-${tokenTransaction.imgType.toLowerCase()}-icon.png`}
                    alt={`${tokenTransaction.imgType}-icon`}
                  />
                </div>
                <p className="mn-gray i-txt">{tokenTransaction.coinType}</p>
              </div>
              <div className="txt-box">
                <div className="top">
                  <div className="sendOrReceiveAndButton-wrap">
                    <p className="body-l">{tokenTransaction.type}</p>
                    <div
                      className={clsx('bottom status', {
                        success: tokenTransaction.status === '성공',
                        fail: tokenTransaction.status === '실패',
                      })}
                    >
                      {tokenTransaction.status}
                    </div>
                  </div>
                  <div className="linkAndMemo">
                    <div className="destination">
                      <i
                        className={clsx(
                          'bi',
                          {
                            'bi-arrow-right-short': tokenTransaction.type === '보내기',
                            'bi-arrow-left-short': tokenTransaction.type === '받기',
                          },
                          'body-xl ml-gray',
                        )}
                      ></i>
                      <p className="body-n" onClick={handleCopyClick}>
                        {tokenTransaction.type === '보내기' ? tokenTransaction.to_short : tokenTransaction.from_short}
                      </p>
                      <i className="bi bi-files" onClick={handleCopyClick}></i>
                    </div>
                    <span className="activity-memo body-s-n">
                      {tokenTransaction.type === '보내기' ? tokenTransaction.to_memo : tokenTransaction.from_memo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="top">
                <p className="body-xl">{tokenTransaction.amount}</p>
                <span className="ml-gray i-txt">{tokenTransaction.krwAmount}</span>
              </div>
            </div>
          </div>
        </a>
      </li>
    </>
  );
};

export default TokenTransactionItem;
